import { getVersionId } from '@databases/database-state';
import { PluginKey } from '@databases/plugins';
import { isPluginEnabled } from '@databases/plugins/helper';
import { defaultStoreUtils } from '@databases/redux';
import { selectDatabaseByContentIdRequired } from '@databases/utils/redux/databases/selectors';

type UseCanEditFieldsOptions = {
  contentId: string;
};

export const useCanEditFields = ({ contentId }: UseCanEditFieldsOptions) => {
  const versionId = getVersionId();
  const isViewingPreviousVersion = !!versionId;

  const [couldEditFields, canEditFields, isLocked] = defaultStoreUtils.useEqualSelector(
    (state) => {
      const database = selectDatabaseByContentIdRequired(state, { contentId });
      const isLocked = database.meta.isLocked;
      const couldEditFields =
        !isViewingPreviousVersion &&
        database.operations.updateMetadata &&
        isPluginEnabled(PluginKey.EDIT_CONTENT);
      const canEditFields = couldEditFields && !isLocked;
      return [couldEditFields, canEditFields, isLocked] as const;
    }
  );

  return { canEditFields, couldEditFields, isLocked, isViewingPreviousVersion };
};
